import { FindParams } from './find-params';

export interface FindPhoneConfigurationParams extends FindParams {
  charity_id?: string;
  store_id?: string;
}
